import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router";
// react redux
import { useSelector } from "react-redux";
// react-hook-form
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
// axios
import EnhancedAxios from "../../axios/EnhancedAxios";
import { AxiosResponse, AxiosError } from "axios";
// mui
import { Stack, FormControlLabel, Switch } from "@mui/material";
// componennts
import {
    PageTitle,
    SubmitButton,
    InputField,
    ImagePreview,
    ThreeDotsLoader,
    SelectApp,
} from "../../components";
// schema
import { editBannerSchema } from "../../schemes/banner/editBannerSchema";
import { errorAlert, successAlert } from "../../utils/alerts/alerts";
// types
import { ReduxUserReducerState } from "../../types/global";
// form values type
type FormValues = {
    img?: File;
    url: string;
    is_disabled: boolean;
    category: string;
};

const EditBanner = () => {
    const navigate = useNavigate();
    const { bannerId } = useParams();
    const userToken = useSelector(
        (state: ReduxUserReducerState) => state.user.userToken
    );
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(true);
    const [defaultImg, setDefaultImg] = useState("");
    // --------------------------- form handle ---------------------------
    const form = useForm<FormValues>({
        defaultValues: {
            img: undefined,
            url: "",
            is_disabled: false,
            category: "",
        },
        resolver: yupResolver(editBannerSchema),
        mode: "all",
    });
    const {
        register,
        setValue,
        reset,
        getValues,
        watch,
        control,
        formState: { errors },
        handleSubmit,
    } = form;
    // submit function
    const onSubmit: SubmitHandler<FormValues> = (data: any) => {
        const formData: any = new FormData();
        const formattedData = {
            ...data,
            category: JSON.stringify({ id: data.category }),
        };
        for (let key in formattedData) {
            formData.append(key, formattedData[key]);
        }
        setSubmitting(true);
        EnhancedAxios("multipart/form-data", userToken)
            .put(`/admin/banners/${bannerId}`, formData)
            .then((res: AxiosResponse) => {
                successAlert(`تم تعديل البانر `);
                setSubmitting(false);
                navigate(-1);
            })
            .catch((error: AxiosResponse) => {
                errorAlert(error);
                setSubmitting(false);
            });
    };
    // get category data
    useEffect(() => {
        EnhancedAxios(null, userToken)
            .get(`/admin/banners/${bannerId}`)
            .then((res: any) => {
                setDefaultImg(res.data.img);
                reset({
                    img: res.data.img,
                    url: res.data.url,
                    is_disabled: res.data.is_disabled,
                    category: res.data.category?.id,
                });
                setLoading(false);
            })
            .catch((error: any) => {
                errorAlert(error);
            });
    }, []);
    if (loading) return <ThreeDotsLoader />;
    return (
        <Stack gap="20px">
            <PageTitle title="تعديل بانر" />
            <Stack alignItems="center">
                <Stack
                    width="100%"
                    maxWidth="800px"
                    gap="10px"
                    component="form"
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <ImagePreview
                        setValue={setValue}
                        errorMessage={errors?.img?.message}
                        IPObjectFit="contain"
                        defaultImage={defaultImg}
                    />
                    <InputField
                        type="url"
                        registration={{ ...register("url") }}
                        label="الرابط"
                        errorMessage={errors?.url?.message}
                    />
                    <SelectApp
                        errorMessage={errors?.category?.message}
                        control={control}
                    />
                    <Controller
                        name="is_disabled"
                        control={control}
                        render={({ field }) => (
                            <FormControlLabel
                                control={
                                    <Switch
                                        {...field}
                                        checked={!watch("is_disabled")}
                                        onChange={(e) =>
                                            setValue(
                                                "is_disabled",
                                                !e.target.checked
                                            )
                                        }
                                    />
                                }
                                label="مفعل"
                            />
                        )}
                    />
                    <SubmitButton label="تعديل" disabled={submitting} />
                </Stack>
            </Stack>
        </Stack>
    );
};

export default EditBanner;
